import Axios from 'axios';
import { setItem, setItems, setItemPackage, setSearchSummary } from './actions';
import { setSearchStatus } from '../search/actions';
import config from '../../../common/config';

export const requestGetItem = (id) => (dispatch) => {
  return Axios.get(`${config.apiBaseUrl}/items/${id}`).then(
    ({ data: item }) => {
      dispatch(setItem(item));
    }
  );
};

export const requestGetItems = (query, page, sort, filters) => (dispatch) => {
  dispatch(setSearchStatus('running'));
  Axios.post(`${config.apiBaseUrl}/items/search`, {
    query,
    sort,
    skip: (page - 1) * 24,
    ...filters,
  }).then(({ data: items }) => {
    dispatch(setItems(items));
    dispatch(setSearchStatus('done'));
  });
};

export const requestSearchSummary = (query) => (dispatch) => {
  dispatch(setSearchStatus('running'));
  Axios.post(`${config.apiBaseUrl}/items/searchSummary?query=${query}`, {
    query,
  }).then(({ data: summary }) => {
    dispatch(setSearchStatus('done'));
    dispatch(setSearchSummary(summary));
    return summary;
  });
}

export const requestGetItemPackage = (itemPackage) => (dispatch) => dispatch(setItemPackage(itemPackage));